function MarketRegionCell(props) {
    return <>{props.value?.label ?? "-"}</>;
}

export default MarketRegionCell;
